import React from "react";
import classes from './Footer.module.css';
import { useNavigate } from "react-router-dom";

const Footer = () => {

    const navigate = useNavigate();

    return (
        <>
            <div className={classes['outer-container']}>
                
                <div className={classes['container-one']} >
                    <img className={classes['footer-img']}  src="https://static.wixstatic.com/media/da937f_d083a478b4c54fc8abaeaa8dc8360b92~mv2.png/v1/fill/w_142,h_50,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/New%20Project%20(19).png" alt="" />
                    <p className={classes['footer-desc']} style={{width:"60%",wordBreak:"break-word",color:"white",fontSize:"1.2vw",marginLeft:"1.4vw"}}>We promise to make sure we only update you with the most important announcements</p>
                </div>

                <div className={classes['div-1']} >
                    <p onClick={()=>{navigate('/aboutus')}} style={{marginBottom:"0.5vw",fontFamily:"dm-sans-medium",cursor:"pointer"}}>About Us</p>
                    <p onClick={()=>{navigate('/explorerclub')}} style={{marginBottom:"0.5vw",fontFamily:"dm-sans-medium",cursor:"pointer"}}>For Explorer</p>
                    <p onClick={()=>{navigate('/influencerclub')}} style={{marginBottom:"0.5vw",fontFamily:"dm-sans-medium",cursor:"pointer"}}>For Influencer</p>
                    
                </div>

                <div className={classes['div-2']} >
                    <p onClick={()=>{navigate('/blogs')}} style={{marginBottom:"0.5vw",fontFamily:"dm-sans-medium",cursor:"pointer"}}>Blogs</p>
                    <p onClick={()=>{navigate('/privacypolicy')}} style={{marginBottom:"0.5vw",fontFamily:"dm-sans-medium",cursor:"pointer"}}>Privacy Policy</p>
                    <p onClick={()=>{navigate('/termsandconditions')}} style={{marginBottom:"0.5vw",fontFamily:"dm-sans-medium",cursor:"pointer"}}>Terms and Conditions</p>
                </div>

                <div className={classes['footer-bg-container']}>
                <img className={classes['footer-bg-img']} src="https://static.wixstatic.com/media/da937f_aa358c2b10694543b70db66ecf5ef43f~mv2.png/v1/crop/x_0,y_185,w_6324,h_2733/fill/w_631,h_272,fp_0.50_0.50,q_85,usm_0.66_1.00_0.01,enc_auto/Exploro%20Logic%20(18).png" alt ="" />
                </div>

            </div>
        </>
    )
};

export default Footer;
